import axiosInstance from './axiosInstance';

/**
 * 지원하기
 * @param {{ castingPostId, talentProfileId, castingRoleId, message, attachmentFileIds?: number[], videoLink?: string }} data
 * @returns {{ id: number }}
 */
export const apply = async (data) => {
  const res = await axiosInstance.post('/api/applications', data);
  return res.data;
};

/**
 * 공고별 지원자 목록
 * @param {number} postId
 * @param {string} [status] - "SUBMITTED"|"PASS_1"|"PASS_2"|"PASS_3"|"PASS_4"|"HIRED"|"REJECTED"|"WITHDRAWN" (optional)
 * @returns {ApplicationListItemDto[]}
 */
export const getApplicationsByPost = async (postId, status) => {
  const res = await axiosInstance.get(`/api/applications/post/${postId}`, {
    params: status ? { status } : undefined,
  });
  return res.data;
};

/**
 * 지원 상태 변경 (제작사)
 * @param {number} id
 * @param {"PASS_1"|"PASS_2"|"PASS_3"|"PASS_4"|"HIRED"|"REJECTED"} status
 * @param {string} [comment]
 * @param {string} [dueDate] - 다음 단계 기한 (예: "2026-04-20")
 * @param {number} [stageId] - AuditionStage ID (GET /api/castings/{id}.stages[].id)
 */
export const changeApplicationStatus = async (id, status, comment, dueDate, stageId) => {
  await axiosInstance.patch(`/api/applications/${id}/status`, {
    status,
    ...(comment && { comment }),
    ...(dueDate && { dueDate }),
    ...(stageId != null && { stageId }),
  });
};

/**
 * 내 지원 목록 (배우)
 * @returns {ListItemDto[]} - { id, castingPostId, castingPostTitle, companyName, roleName, status, submittedAt }
 */
export const getMyApplications = async () => {
  const res = await axiosInstance.get('/api/applications/my');
  return res.data;
};

/**
 * 지원 상세
 * @param {number} id
 */
export const getApplicationDetail = async (id) => {
  const res = await axiosInstance.get(`/api/applications/${id}`);
  return res.data;
};

/**
 * 평점 조회 (제작사)
 * @param {number} applicationId
 * @returns {{ rating: number|null }}
 */
export const getApplicationRating = async (applicationId) => {
  const res = await axiosInstance.get(`/api/applications/${applicationId}/rating`);
  return res.data;
};

/**
 * 평점 저장 (제작사)
 * @param {number} applicationId
 * @param {number} rating - 1~5
 */
export const saveApplicationRating = async (applicationId, rating) => {
  const res = await axiosInstance.post(`/api/applications/${applicationId}/rating`, { rating });
  return res.data;
};
